import * as React from 'react';
import { SVGProps } from 'react';
const GiftIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlSpace="preserve"
		id="Layer_1"
		x={0}
		y={0}
		enableBackground="new 0 0 23.8 24.1"
		viewBox="0 0 23.8 24.1"
		{...props}
	>
		<style>{'.st0{fill:#191d22}'}</style>
		<g id="Group_1432">
			<path id="Path_2770" d="M13.2.5c0-.3-.2-.5-.5-.5-.8.1-1.6.3-2.4.7-.5.2-1 .6-1.3 1.2h4.2V.5z" className="st0" />
			<path id="Path_2771" d="M6.2.7C5.4.3 4.6.1 3.8 0c-.3 0-.5.2-.5.5v1.4h4.2c-.3-.6-.8-1-1.3-1.2" className="st0" />
			<path id="Path_2772" d="M16.5 4.3v2.2H0V4.3c0-.7.5-1.2 1.2-1.2h14.1c.7 0 1.2.6 1.2 1.2" className="st0" />
			<path id="Path_2773" d="M.6 17.4c0 .7.5 1.2 1.2 1.2h5.9V7.8H.6v9.6z" className="st0" />
			<path id="Path_2774" d="M23.8 13.4v1.8H9.5v-1.8c0-.5.4-1 1-1h12.4c.5.1.9.5.9 1" className="st0" />
			<path id="Path_2775" d="M17.3 24.1h5.1c.5 0 1-.4 1-1v-6.5h-6v7.5z" className="st0" />
			<path id="Path_2776" d="M10 23.1c0 .5.4 1 1 1h5v-7.5h-6v6.5z" className="st0" />
			<path
				id="Path_2777"
				d="M11.1 11.2v-1.1c0-.9.7-1.6 1.6-1.6 1.1.1 2.2.5 3.2 1.1V7.8h-7v4c.4-.4 1-.6 1.5-.6h.7z"
				className="st0"
			/>
			<path
				id="Path_2778"
				d="M14.8 10.3c-.6-.3-1.3-.5-2-.6-.2 0-.3.2-.3.3v1.5h3.6c-.1-.3-.6-.8-1.3-1.2"
				className="st0"
			/>
			<path
				id="Path_2779"
				d="M20.9 10.1c0-.2-.1-.3-.3-.3-.7.1-1.4.3-2 .6-.8.4-1.2.8-1.2 1.2H21v-1.5z"
				className="st0"
			/>
		</g>
	</svg>
);
export default GiftIcon;
